/**
 * 인증 보호 라우트 컴포넌트
 * - 인증되지 않은 사용자 차단
 * - 역할 기반 접근 제어
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthStore } from '../../store/authStore';
import { UserRole } from '../../types/user';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

/**
 * 인증 보호 라우트
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const { user, isAuthenticated, isLoading } = useAuthStore();
  const location = useLocation();

  // 로딩 중
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: '16px',
        }}
      >
        <Spin size="large" />
        <div style={{ color: '#666' }}>로딩 중...</div>
      </div>
    );
  }

  // 인증되지 않음 → 로그인 페이지로
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 역할 제한이 있는 경우 확인
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // 권한 없음 → 역할별 기본 페이지로
    switch (user.role) {
      case 'admin':
        return <Navigate to="/system" replace />;
      case 'group_admin':
      case 'instructor':
        return <Navigate to="/dashboard" replace />;
      case 'student':
        return <Navigate to="/workbooks" replace />;
      default:
        return <Navigate to="/login" replace />;
    }
  }

  // 인증 및 권한 통과
  return <>{children}</>;
};
